import script from "./uploaddocument.vue?vue&type=script&setup=true&lang=js"
export * from "./uploaddocument.vue?vue&type=script&setup=true&lang=js"

import "./uploaddocument.vue?vue&type=style&index=0&id=a7835f3e&lang=css"

const __exports__ = script;

export default __exports__